
const TheScheduledTaskIndexPage = () =>
  import('@/views/scheduledTask/TheScheduledTaskIndexPage.vue')

export const scheduledTaskSubPages = [
  {
    path: '/scheduled',
    name: 'scheduled_task_list_route',
    component: TheScheduledTaskIndexPage
  }
]
